
    import { mapState, mapGetters } from 'vuex';
    import LazyHydrate from 'vue-lazy-hydration';
    import SearchMixin from '@/components/Search/SearchMixin';
    import CompanyDetailsDesktop from '@/components/Company/CompanyDetailsDesktop';
    import CompanyCarouselLightbox from '@/components/Company/CompanyCarouselLightbox';
    import CompanyHeader from '@/components/Company/CompanyHeader';
    import SearchResultHeader from '@/components/Search/SearchResultHeader';
    import SearchJobList from '@/components/Search/SearchJobList';
    import JobViewModalMixin from '@/components/JobViewModal/JobViewModalMixin';
    import CompanyPerks from '@/components/Company/CompanyPerks';
    import CompanyIntro from '@/components/Company/CompanyIntro';
    import BackButton from '@/components/Utils/BackButton';
    import sassCommonVariables from '@/assets/sass/common/_common-variables.scss';

    export default {
        name: 'SearchPageCompany',

        components: {
            LazyHydrate,
            CompanyHeader,
            CompanyDetailsDesktop,
            CompanyCarouselLightbox,
            CompanyPerks,
            CompanyIntro,
            SearchResultHeader,
            SearchJobList,
            BackButton,
            // CompanyDetailsMobile: () => import(/* webpackChunkName: "CompanyDetailsMobile" */'@/components/Company/CompanyDetailsMobile'),
            SearchbarDetailed: () => import(/* webpackChunkName: "SearchbarDetailed" */'@/components/Search/Searchbars/SearchbarDetailed'),
            EducationSlideWidget: () => import(/* webpackChunkName: "EducationSlideWidget" */'@/components/Education/EducationSlideWidget'),
            GetJobMatchesOnboarding: () => import(/* webpackChunkName: "GetJobMatchesOnboarding" */'@/components/Utils/GetJobMatchesOnboarding'),
            SearchMessage: () => import(/* webpackChunkName: "HeaderNonLoggedIn" */'@/components/Search/SearchMessage'),
            SearchResultLoading: () => import(/* webpackChunkName: "HeaderNonLoggedIn" */'@/components/Search/SearchResultLoading'),
            Pagination: () => import(/* webpackChunkName: "HeaderNonLoggedIn" */'@/components/Utils/Pagination'),
            AdUnit: () => import(/* webpackChunkName: "HeaderNonLoggedIn" */'@/components/Ad/AdUnit'),
            CompanyArticles: () => import(/* webpackChunkName: "CompanyArticles" */'@/components/Company/CompanyArticles'),
        },

        mixins: [SearchMixin, JobViewModalMixin],

        data() {
            return {
                sassCommonVariables,
            };
        },

        computed: {
            ...mapState({
                $_brandArticles: state => state.search.brandArticles,
            }),

            ...mapGetters('search', {
                $_companyName: 'companyName',
                $_companySlug: 'companySlug',
                $_companyAbout: 'companyAbout',
                $_companySize: 'companySize',
                $_companyMedias: 'companyMedias',
                $_companyWebsite: 'companyWebsite',
                $_companySector: 'companySector',
                $_companyHasPaidJobs: 'companyHasPaidJobs',
            }),

            hasCompanyDetails() {
                return this.$_companyWebsite || this.$_companySector || this.$_companySize || this.$_companyAbout;
            },
        },

        methods: {
            goBack() {
                if (history.length > 2) {
                    this.$router.back();
                } else {
                    window.location.href = this.$jobSearchUrlPath;
                }
            },
        },
    };
